<template>
  <div>
    <div class="d-flex flex-row flex-wrap">
      <template v-for="question in questions">
        <div
          v-if="question.answer"
          class="pe-8"
          style="flex: 0 0 50%;"
          :key="question.key"
        >
          <p class="body3 mb-5 black--text">
            <b
              >{{
                $t(`problem_solving.problem_tool.${getKey(question.key)}`)
              }}:</b
            >
            <br />
            {{ question.answer }}
          </p>
        </div>
      </template>
    </div>

    <v-divider class="ma-0" />

    <p class="body3 my-6 grey--text text--darken-1" v-if="isEditMode">
      {{ $t('problem_solving.problem_tool.problem_definition_instructions') }}
    </p>
    <v-textarea
      data-private
      v-model="problem"
      outlined
      class="mt-5"
      rows="1"
      dense
      no-resize
      auto-grow
      :disabled="!isEditMode"
      :placeholder="
        $t('problem_solving.problem_tool.problem_definition_placeholder')
      "
      :maxlength="$constants.problemSolving.problemMaxLength"
      :counter="$constants.problemSolving.problemMaxLength"
      :label="$t('problem_solving.problem_tool.problem_definition_label')"
      @input="$emit('input', $event.trim())"
    ></v-textarea>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'Define',

  props: {
    questions: {
      type: Array,
      required: true,
    },
    problemDescription: {
      type: String,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      problem: this.problemDescription,
    }
  },

  methods: {
    getKey(key) {
      return _.snakeCase(key)
    },
  },
}
</script>
